(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.taven-majestic-root').forEach((root) => {
      if (root.dataset.tavenInitialized) return;
      root.dataset.tavenInitialized = 'true';
      const departmentMenu = root.querySelector('.tm-departments');
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && departmentMenu?.open) {
          departmentMenu.open = false;
          departmentMenu.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (departmentMenu?.open && !departmentMenu.contains(event.target)) departmentMenu.open = false;
      });
      const scrollRegions = root.querySelectorAll('[data-taven-scroll-region]');
      const syncScrollRegions = () => {
        scrollRegions.forEach((region) => {
          if (region.scrollWidth > region.clientWidth + 1) region.setAttribute('tabindex', '0');
          else region.removeAttribute('tabindex');
        });
      };
      syncScrollRegions();
      if ('ResizeObserver' in window) {
        const scrollRegionObserver = new ResizeObserver(syncScrollRegions);
        scrollRegions.forEach((region) => scrollRegionObserver.observe(region));
      } else {
        window.addEventListener('resize', syncScrollRegions, { passive: true });
      }
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('tm-is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.06, rootMargin: '0px 0px 30px 0px' });
      root.classList.add('tm-motion-ready');
      root.querySelectorAll('[data-taven-reveal]').forEach((element) => observer.observe(element));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
